export default {
    playAudioBuffer(buffer) {
        return new Promise((resolve, reject) => {
            if (!buffer) {
                reject();
            }

            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            let context = new AudioContext();
            let targetBuffer;
            let arrayBuffer = this.toArrayBuffer(buffer);
            try{
                this.saveAudioToLocal(buffer, "test");
                resolve();
            }catch(err){
                reject();
            }
            
            // context.decodeAudioData(arrayBuffer, function(res) {
            //     targetBuffer = res;
            //     const source = context.createBufferSource();
            //     source.buffer = targetBuffer;
            //     source.connect(context.destination);
            //     source.start(0);

            //     source.onended = (event) => {
            //         console.log('Audio ended');
            //         resolve();
            //     };

            //     source.onerror = (error) => {
            //         console.log('error',error);
            //         reject(error);
            //     };
            //   }, (error)=>{
            //       reject(error);
            //   });


        });
    },

    toArrayBuffer(buf) {
        var ab = new ArrayBuffer(buf.length);
        var view = new Uint8Array(ab);
        for (var i = 0; i < buf.length; ++i) {
            view[i] = buf[i];
        }
        return ab;
    },

    saveAudioToLocal(data, fileName) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        let dataitself = Buffer.from(data);
        let blob = new Blob([dataitself], { type: "audio/mpeg charset=windows-1252" });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}